import React from 'react'

import { Shimmer } from '@wartek-id/shimmer'

const LearningGroupLoading = () => {
  return (
    <div className="h-[92px] bg-white mb-3 rounded shadow-card p-4 flex flex-col justify-between">
      <Shimmer width={27} height={16}></Shimmer>
      <div className="flex gap-4">
        <Shimmer className="w-[20%]" height={16} />
        <Shimmer className="flex-1" height={16} />
      </div>
    </div>
  )
}

export default LearningGroupLoading
